import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCoQ } from 'services/glass-management/glassManagement';

export const fetchCoq = createAsyncThunk('glass/coq/fetch', async (filters) => {
    const res = await getCoQ(filters.start, filters.end);
    return { data: res };
});

export const coqSlice = createSlice({
    name: 'glassCoq',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchCoq.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCoq.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchCoq.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load CoQ';
                state.data = null;
            });
    }
});

export default coqSlice.reducer;
